import { COffcanvasTitle } from "@coreui/bootstrap-react";
import create from "zustand";

const tuplacatalogoStore = create((set, get:any) => ({
  tupla:{},
  catalogo:[],
  objError: { url: "", recurso: "", body: "", hasError: false, function:"",  resultado: { "idresul": 0,  "desresul": "" } }, 
//guarda el catalogo generado a travez de la tupla
  setTuplaCatalogo: async (cat:any) => {
    set({catalogo:cat});
 },
 //guarda la tupla generada a travez del catalogo
  setCatalogoTupla: async (tup:any) => {
    set({tupla: tup});
  },
}));

export default tuplacatalogoStore;